export const safeParseJson = <Value>(jsonString: string): Value | undefined => {
  try {
    return JSON.parse(jsonString) as Value;
  } catch (e) {
    return undefined;
  }
};
